import { content } from '../data/content';
import { PRODUCT, SOCIAL } from '../data/product';
import Logo from './Logo';

const LINKS = [
  { label: content.navProblem, href: '#problem' },
  { label: content.navFeatures, href: '#features' },
  { label: content.navSafety, href: '#safety' },
  { label: content.navFaq, href: '#faq' },
];

const CHANNELS = [
  { icon: 'fa-whatsapp', label: 'واتساب zalyas', href: `https://wa.me/${PRODUCT.whatsapp}` },
  { icon: 'fa-facebook-f', label: 'صفحة zalyas على فيسبوك', href: SOCIAL.facebook },
  { icon: 'fa-instagram', label: 'حساب zalyas على إنستغرام', href: SOCIAL.instagram },
];

/**
 * فوتر أبيض. القسم الأخير قبله أبيض أيضاً، فالفصل يأتي من خط علوي رفيع لا من
 * تغيّر اللون — والشريط الأحمر السميك الذي كان يفصل الفوتر الكحلي صار ثقيلاً
 * على الأبيض. اللوجو يظهر مباشرة بلا مربّع أبيض حوله كما كان يلزم فوق الكحلي.
 *
 * عناوين الأعمدة h3 لا h4: آخر عنوان قبل الفوتر هو h2، والقفز درجة كاملة
 * يكسر تسلسل العناوين الذي تعتمد عليه قارئات الشاشة في التنقّل.
 */
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    // مسافة سفلية إضافية على الموبايل حتى لا يغطي الشريط الثابت المحتوى
    <footer className="bg-white border-t border-gray-200 pt-12 md:pt-16 pb-24 md:pb-8">
      <div className="container mx-auto">
        {/*
          على الجوال يتوسّط العمود الأول: اللوجو وحده على اليمين يترك فراغاً
          واسعاً على يساره فتبدو الزاوية فارغة، والتوسيط يوازن الكتلة. من md
          تعود المحاذاة الطبيعية لأن الأعمدة الأربعة تملأ العرض.
        */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8 mb-10">
          <div className="md:col-span-2 text-center md:text-start">
            <Logo className="text-4xl mb-4" />
            <p className="text-z-gray text-sm max-w-sm mx-auto md:mx-0 mb-6 leading-relaxed">{content.footerDesc}</p>
            {/* aria-label يحمل اسم الحساب كاملاً لا «فيسبوك» فقط: ثلاثة روابط
                بأسماء عامة تُقرأ متطابقة على قارئ الشاشة وتُحسب تكراراً */}
            <div className="flex gap-3 justify-center md:justify-start">
              {CHANNELS.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  aria-label={item.label}
                  target="_blank"
                  rel="noopener noreferrer me"
                  className="w-10 h-10 rounded-full border border-gray-200 text-z-navy flex items-center justify-center hover:bg-z-red hover:text-white hover:border-z-red transition"
                >
                  <i className={`fa-brands ${item.icon}`} />
                </a>
              ))}
            </div>
          </div>

          <div className="text-center md:text-start">
            {/* شرطة حمراء قصيرة فوق العنوان بدل الخط السفلي — أوضح على الأبيض */}
            <span className="block w-8 h-0.5 bg-z-red rounded-full mb-3 mx-auto md:mx-0" />
            <h3 className="font-bold text-z-navy mb-4">{content.footerLinksTitle}</h3>
            <ul className="space-y-3 text-sm text-z-gray">
              {LINKS.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="hover:text-z-red transition">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="text-center md:text-start">
            <span className="block w-8 h-0.5 bg-z-red rounded-full mb-3 mx-auto md:mx-0" />
            <h3 className="font-bold text-z-navy mb-4">{content.footerContact}</h3>
            <ul className="space-y-3 text-sm text-z-gray">
              <li>
                <a
                  href={`https://wa.me/${PRODUCT.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center md:justify-start gap-2 hover:text-z-green transition"
                >
                  <i className="fa-brands fa-whatsapp text-z-green" />
                  <span dir="ltr">{PRODUCT.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${PRODUCT.phone.replace(/\s/g, '')}`}
                  className="flex items-center justify-center md:justify-start gap-2 hover:text-z-red transition"
                >
                  <i className="fa-solid fa-phone text-z-navy/40" />
                  {content.footerCall}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-sm text-z-gray">
          <p>
            &copy; {year} <span className="font-serif font-bold text-z-navy">zalyas</span>. {content.copyright}
          </p>
          <p className="flex items-center gap-2">
            <i className="fa-solid fa-hand-holding-dollar text-z-orange" /> {content.trustCod}
          </p>
        </div>
      </div>
    </footer>
  );
}
